const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the media viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the global Analyze functions and properties
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Assignments} Assignments the resource defined to manage Assignments
 */
app.directive('fileViewer', ['Application', 'Authorization', 'Analyze', 'Files', 'ContentAuth', 'SurveyHelper', 'Content', '$translate', function (Application, Authorization, Analyze, Files, ContentAuth, SurveyHelper, Content, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contentId: '=',
      checkFull: '@',
      fullData: '=',
      onComplete: '&',
      potent: '@?',
      trackId: '=?',
      allowComments: '&?',
      journeyId: '=?',
      preview: '<',
    },
    template: require('../../templates/directives/file-viewer.html'),
    controller: ['$scope', '$sce', '$timeout', '$window', function ($scope, $sce, $timeout, $window) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      self.currentUrl = Application.navigation.getUrl();
      self.allowedRoles = ['admin', 'creator'];
      self.routeParameters = Application.navigation.getRouteParameters();
      self.isAdmin = self.allowedRoles.indexOf(Authorization.getAuthToken().user.role) !== -1;
      self.contentType = 'file';
      self.translations = {};
      self.expandSurvey = false;
      self.hideSurvey = true;

      self.contentId = $scope.contentId;
      self.inTrack = new RegExp('track').test(self.currentUrl) || !!$scope.trackId;
      self.inJourney = !!$scope.journeyId;
      self.inEditing = new RegExp('edit').test(self.currentUrl);
      self.isPdf = false;

      self.recordSurveyView = () => {
        Analyze.record({resource: 'views'}, {content: $scope.surveyId, content_type: 'survey'});
      }

      self.tracking = new Application.Tracking(Analyze, moment, 'file', $scope.trackId || null);
      if (self.inTrack && !$scope.trackId) {
        var trackWatch = $scope.$watch('trackId', function(newVal) {
          if (newVal) {
            self.tracking.setTrackId($scope.trackId);
            trackWatch();
          }
        });
      }

      self.displayTime = function(time) {
        if (time && time < 60) {
          return self.translations['fileviewer.less_than_a_minute'];
        }
        var mins = ~~(time / 60);
        var secs = time % 60;

        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = time % 60;

        var ret = "";

        if (hrs > 0) {
          ret += "" + hrs + (hrs === 1 ? " hr" : " hrs") + " ";
        }

        ret += "" + mins + (mins === 1 ? " min" : " mins");

        return ret;
      };

      self.file;

      self.data = {
        loading: false,
        markedComplete: false,
        idInit: function (callback) {
          self.data.markedComplete = false;
          self.contentId = $scope.contentId;
          this.loading = true;

          var options = {
            fileId: self.contentId,
            fields: 'user,title,author,duration,category,type,link,link_name,description,images,explore_hide,source,source_id,tags,linked_category,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,downloadable,completion_percent,embed,embed_settings,rating_configuration,average_rating,allow_comments,groups,surveys',
            'user-populate': 'first_name,last_name,email'
          };

          Files.get(options , function (data) {
            ContentAuth.allowView(data).then(async function(allowed) {
              if (!allowed) {
                Application.messaging.addMessage({type: 'error', text: self.translations['fileviewer.error_permission'], duration: 5});
                Application.navigation.back();
                return;
              }

              self.isPdf = false;
              if (data.embed) {
                self.source = $sce.trustAsResourceUrl(data.link);
              } else if (data.link && typeof data.link.slice(-3) === 'string' && data.link.slice(-3).toLowerCase() === 'pdf') {
                self.isPdf = true;
              } else if (data.source_v2) {
                self.source = $sce.trustAsResourceUrl(data.source_v2);
              }

              if (data.allow_comments && $scope.allowComments) {
                $scope.allowComments();
              }

              self.file = data;            
              self.tracking.start(self.file);
              $window.document.title = self.file.title;
              if (self.file.average_rating) {
                self.rating = Math.round(self.file.average_rating * 5) / 100;
              }
              if (!self.file.completion_percent) {
                self.data.completionActions();
              }
              if (self.file.surveys?.length) {
                const hideInContext = self.inJourney || self.inTrack;
                self.hideSurvey = await SurveyHelper.hideSurvey(hideInContext, self.file.surveys[0].survey_id, self.file._id);
                $scope.$apply();
              }

              Analyze.record({resource: 'views'}, {content: data._id, content_type: 'file'});
              Application.analyticsProvider.trackEvent('file_viewed', {content: data._id, content_type: 'file', title: data.title});
              self.data.loading = false;
            });
          }, function (error) {
            console.log('Error occured getting File ', error);
            Application.notifications.setError(self.translations['fileviewer.unable_to_get']);
            self.data.loading = false;
          });
        },
        fullDataInit: function() {
          self.isPdf = false;
          if (!$scope.fullData.link) {
            return;
          }

          self.data.markedComplete = false;
          self.file = $scope.fullData;
          if (self.file.embed) {
            self.isPdf = false;
            self.source = $sce.trustAsResourceUrl(self.file.link);
            if (!self.file.completion_percent) {
              self.data.completionActions();
            }
            self.tracking.start(self.file);
            return;
          } else if (self.file.link && typeof self.file.link.slice(-3) === 'string' && self.file.link.slice(-3).toLowerCase() === 'pdf') {
            self.isPdf = true;
            if (!self.file.completion_percent) {
              self.data.completionActions();
            }
            self.tracking.start(self.file);
            return;
          } else if (!$scope.fullData.source_v2 && Application.navigation.getUrl().indexOf('tracks') === -1) {
            self.source = $sce.trustAsResourceUrl($scope.fullData.link);
            if (!self.file.completion_percent) {
              self.data.completionActions();
            }
            self.tracking.start(self.file);
            return;
          } else if ($scope.fullData.source_v2) {
            self.source = $sce.trustAsResourceUrl($scope.fullData.source_v2);
            if (!self.file.completion_percent) {
              self.data.completionActions();
            }
            self.tracking.start(self.file);
            return;
          }

          this.loading = true;
          var options = {
            fileId: $scope.fullData._id,
            fields: 'link,link_name,source_v2,source_id_v2,downloadable,embed,embed_settings,rating_configuration,average_rating,allow_comments,groups,surveys',
          };
          // Retrieve only the source of the box viewer. (specific to files route)
          Files.get(options , function (data) {
            if(data.source_v2) {
              self.source = $sce.trustAsResourceUrl(data.source_v2);
            }
            self.data.loading = false;
            if (!self.file.completion_percent) {
              self.data.completionActions();
            }
            self.tracking.start(self.file);
          }, function (error) {
            self.data.loading = false;
          });
        },
        completionActions: function() {
          if (self.data.markedComplete) {
            return;
          }
          if ($scope.preview) {
            return;
          }
          self.data.markedComplete = true;

          if ($scope.onComplete) {
            $scope.onComplete();
          } else if (self.inTrack) {
            var completeWatch = $scope.$watch('onComplete', function(newVal, oldVal){
              if (newVal && !oldVal) {
                $scope.onComplete();
                completeWatch();
              }
            });
          }
          
          const completionContexts = [];
          if (self.inTrack && $scope.trackId) {
            completionContexts.push({key: 'track', value: $scope.trackId});
          }
          if (self.inJourney) {
            completionContexts.push({key: 'journey', value: $scope.journeyId});
          }
          Content.complete({
            type: 'file', 
            id: self.file._id,
            contexts: completionContexts
          });
        }
      };

      // Wait for delayed information
      if (!$scope.contentId) {
        if (!$scope.fullData || $scope.fullData && !$scope.fullData.link) {

          var watchFull = $scope.$watch('fullData.link', function(newVal, oldVal) {
            if (!newVal || oldVal === newVal) {
              return;
            }
            self.data.fullDataInit();
            if (!$scope.potent) {
              watchFull();
            }
          });

          var watchTitle = $scope.$watch('fullData.title', function (newVal, oldVal) {
            if (!newVal || oldVal === newVal) {
              return;
            }
            self.data.fullDataInit();
            if (!$scope.potent) {
              watchTitle();
            }
          });

          return;
        }
      }

      $scope.$on('$destroy', function() {
        self.tracking.end();
      });

      $scope.$watch('contentId', function(newVal, oldVal) {
        if (!newVal || oldVal === newVal) {
          return;
        }
        self.data.idInit();
      });

      $translate([
        'fileviewer.less_than_a_minute',
        'fileviewer.error_permission'
      ]).then(function (translations) {
        self.translations = translations;
        if (!$scope.checkFull) {
          self.data.idInit();
          return;
        }
        // full data scenario
        self.data.fullDataInit();
      });
      
    }],
    controllerAs: 'fileView'
  };
}]);
